import { AdminUserService } from 'tools/bff/generated/bff/admin/admin_user_pb';
//import { LoginService } from 'jce-admin/bff/generated/bff/web/dev_login_pb';
import { createClient } from '@connectrpc/connect';
import { transport } from 'tools/bff/bff';
/**
 * Export a client for each service.
 * Clients provide access to all methods in the gRPC service and return promises.
 *
 * @example
 *   const response = await reservationClient.getReservations({ param: 123 });
 */
// export const loginClient = createClient(LoginService, transport);
export const userClient = createClient(AdminUserService, transport);
